import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'

import {
  changeWizardStepCallback,
  saveCampaignCallback
} from 'Pages/Campaign/recoil/callbacks/callbacks'
import { messageIsOnSentState } from 'Pages/Campaign/recoil/state/page'

const Footer = () => {
  const intl = useIntl()

  const saveCampaign = useRecoilCallback(saveCampaignCallback, [])
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const { isOnSent } = useRecoilValue(messageIsOnSentState)

  const onClickBack = () => {
    changeWizardStep(3)
  }

  const onClickSave = () => {
    saveCampaign('END')
  }

  return (
    <Flex justifyContent='space-between'>
      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        onClick={onClickBack}
        disabled={isOnSent}
        data-mu-test='campaign-wizard__step-4__back-button'
      >
        {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
      </Button>
      <FlexItem>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={onClickSave}
          data-mu-test='campaign-wizard__step-4__save-button'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </Button>
      </FlexItem>
    </Flex>
  )
}

export default Footer
